// 9fbef606107a605d69c0edbcd8029e5d
/**
 *
 * @param {String} phoneNumber Phone Number to validate
 * @return {Boolean}
 */
export const validatePhoneNumber = (phoneNumber) => {
  return /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/i.test(phoneNumber);
};

/**
 *
 * @param {String} phoneNumber phoneNumber to convert
 * @return {String} Returns phoneNumber in format (XXX) XXX-XXXX
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
export const formatPhoneNumber = (phoneNumber, previousValue, phoneData) => {
  const phoneCountryCode = phoneData?.phoneCountryCode || false;

  let normalizePhoneNum = phoneNumber.replace(/[\s()-]/g, '');
  const re = /^[0-9\b]+$/;
  if (!re.test(normalizePhoneNum)) {
    return normalizePhoneNum === '' ? '' : previousValue;
  }

  if (normalizePhoneNum.length > 1 && (phoneCountryCode === '+1' || !phoneCountryCode)) {
    if (normalizePhoneNum.length > 3) {
      normalizePhoneNum = `(${normalizePhoneNum.slice(0, 3)}) ${normalizePhoneNum.slice(3)}`;
    }
    if (normalizePhoneNum.length > 9) {
      normalizePhoneNum = `${normalizePhoneNum.slice(0, 9)}-${normalizePhoneNum.slice(9)}`;
    }
  } else {
    // Generic international number formatting

    if (normalizePhoneNum.length > 3) {
      normalizePhoneNum = `${normalizePhoneNum.slice(0, 3)} ${normalizePhoneNum.slice(3)}`;
    }
    if (normalizePhoneNum.length > 7) {
      normalizePhoneNum = `${normalizePhoneNum.slice(0, 7)} ${normalizePhoneNum.slice(7)}`;
    }
    if (normalizePhoneNum.length > 12) {
      normalizePhoneNum = `${normalizePhoneNum.slice(0, 11)} ${normalizePhoneNum.slice(11)}`;
    }
  }

  return normalizePhoneNum;
};
/**
 *
 * @param {String} value value to convert
 * @return {String} Returns value without spaces,tab and newlines
 */
export const removeSpaces = (value) => {
  return value && value.replace(/[\s]/g, '');
};

export default { validatePhoneNumber, formatPhoneNumber, removeSpaces };
